import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-check.tsx
/**
* icon.16.check
*
* Keywords: checkmark, tick, confirm, validation, approval, complete, verified, accept
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTExLjU4NCAzLjcyM2EuNS41IDAgMCAxIC44MzIuNTU0bC01IDcuNWEuNTAyLjUwMiAwIDAgMS0uNzcuMDc3bC0zLTNhLjUuNSAwIDAgMSAuNzA4LS43MDhsMi41NjggMi41Njl6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11763
*/
const Icon16Check = memo(function Icon16Check(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M11.584 3.723a.5.5 0 0 1 .832.554l-5 7.5a.502.502 0 0 1-.77.077l-3-3a.5.5 0 0 1 .708-.708l2.568 2.569z"
		})
	});
});
//#endregion
export { Icon16Check };

//# sourceMappingURL=icon-16-check.js.map